import React from "react";
import { pxToRem } from "@/util/common";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import FixedNavBar from "@/components/fixedNavBar";
import { createUseStyles } from "react-jss";
import AuthorityNo from "./comp/AuthorityNo";
import UserInfo from "./comp/UserInfo";
import AuthorityAdmin from "./comp/AuthorityAdmin";

const Mine: React.FC = () => {
	const classes = useStyles();
	const { userInfo } = useSelector((state: RootState) => state.auth);

	return (
		<div className="router-main">
			<FixedNavBar title="Me" />
			<div className="router-view">
				<div className={classes.mineWrap}>
					<UserInfo />
					{/* 	1/代理 0/普通用户 */}
					{userInfo?.agentType === 0 ? (
						<AuthorityNo />
					) : (
						<AuthorityAdmin />
					)}
				</div>
			</div>
		</div>
	);
};

export default Mine;
const useStyles = createUseStyles({
	mineWrap: {
		position: "relative",
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(30),
		},
		"&:before": {
			position: "absolute",
			content: '""',
			width: pxToRem(230),
			height: pxToRem(184),
			left: "50%",
			marginLeft: pxToRem(-115),
			transform: "scale(1.5)",
			backgroundImage: `url(${require("@/assets/images/mine/me_bg.png")})`,
			backgroundRepeat: "no-repeat",
			backgroundSize: "cover",
			backgroundPosition: "top center",
		},
	},
});
